import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  height: 36px;\n  margin-left: 10px;\n  flex: 0;\n  min-width: 95px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  flex: 1;\n  color: ", ";\n  line-height: 19px;\n  font-size: 14px;\n  font-weight: 400;\n  width: 100%;\n  outline: none;\n  &::-webkit-search-decoration,\n  &::-webkit-search-cancel-button,\n  &::-webkit-search-results-button {\n    display: none;\n  }\n\n  @media (max-width: ", "px) {\n    font-size: 16px;\n  }\n\n  /* Firefox specific */\n  background-color: transparent;\n  min-width: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 12px;\n  margin: 0 12px;\n  visibility: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 34px;\n  margin: 0 12px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: white;\n  border: solid 1px ", ";\n  border-radius: 18px;\n  height: 36px;\n  width: 195px;\n  min-width: 195px;\n  display: flex;\n  flex: 1;\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { Button } from '../../../Button';
import styled from '../../../utils/styling/styled-components';
import { SEARCH_CLEAR, SEARCH_CTA, SEARCH_TERM, SEARCH_TRIGGER } from '../../../utils/testing/TestIDs';
import { ScreenReaderOnly } from '../../../ScreenReaderOnly';
import CloseSVG from '../../../assets/icons/close-black.svg';
import MagnifyingGlassSVG from '../../../assets/icons/magnifying-glass.svg';
var Wrapper = styled.div(_templateObject());
var Container = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.stoneLight;
}, function (props) {
  return props.theme.breakpoints.md;
});
var SearchTrigger = styled.img(_templateObject3());
var SearchClear = styled.img(_templateObject4(), function (props) {
  return props.visible ? 'visible' : 'hidden';
});
var SearchInput = styled.input(_templateObject5(), function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.theme.breakpoints.sm;
});
var SearchButton = styled(Button)(_templateObject6());
var enhance = compose(withState('searchTerm', 'setSearchTerm', ''), withHandlers(function () {
  var searchInput = null;
  return {
    handleChange: function handleChange(_ref) {
      var setSearchTerm = _ref.setSearchTerm,
          onChange = _ref.onChange,
          disabled = _ref.disabled;
      return function (event) {
        if (!disabled) {
          setSearchTerm(event.target.value);
          onChange(event.target.value);
        }
      };
    },
    handleClear: function handleClear(_ref2) {
      var setSearchTerm = _ref2.setSearchTerm,
          onChange = _ref2.onChange,
          disabled = _ref2.disabled;
      return function () {
        if (!disabled) {
          setSearchTerm('');
          onChange('');
        }
      };
    },
    handleKeyPress: function handleKeyPress(_ref3) {
      var onSearch = _ref3.onSearch,
          searchTerm = _ref3.searchTerm,
          disabled = _ref3.disabled;
      return function (_ref4) {
        var key = _ref4.key;

        if (!disabled && key === 'Enter' && searchTerm) {
          onSearch({
            searchTerm: searchTerm
          });

          if (searchInput) {
            searchInput.blur();
          }
        }
      };
    },
    handleSearch: function handleSearch(_ref5) {
      var onSearch = _ref5.onSearch,
          searchTerm = _ref5.searchTerm,
          disabled = _ref5.disabled;
      return function () {
        if (!disabled && searchTerm) {
          onSearch({
            searchTerm: searchTerm
          });

          if (searchInput) {
            searchInput.blur();
          }
        }
      };
    },
    onRef: function onRef() {
      return function (ref) {
        return searchInput = ref;
      };
    }
  };
}));
var DefaultSearchBox = enhance(function (props) {
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: props.className
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SearchTrigger, {
    onClick: props.handleSearch,
    src: MagnifyingGlassSVG,
    "data-testid": "".concat(SEARCH_TRIGGER),
    alt: ""
  }), /*#__PURE__*/React.createElement(ScreenReaderOnly, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: props.name || props.label
  }, props.label)), /*#__PURE__*/React.createElement(SearchInput, {
    name: props.name || props.label,
    value: props.searchTerm,
    placeholder: props.placeholder || 'Search',
    onChange: props.handleChange,
    onKeyPress: props.handleKeyPress,
    type: "search",
    tabIndex: -1,
    ref: props.onRef,
    "data-testid": "".concat(SEARCH_TERM),
    disabled: props.disabled
  }), /*#__PURE__*/React.createElement(SearchClear, {
    onClick: props.handleClear,
    src: CloseSVG,
    visible: props.searchTerm.length > 0,
    "data-testid": "".concat(SEARCH_CLEAR),
    alt: "Clear."
  })), props.searchButton && /*#__PURE__*/React.createElement(SearchButton, {
    onPress: props.handleSearch,
    disabled: props.searchTerm.length === 0 || props.disabled,
    "data-testid": "".concat(SEARCH_CTA)
  }, "Search"));
});
export { DefaultSearchBox };